(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var _ = require('lodash')
  , deepEqual = require('deep-equal')
  , debug = require('./debug')('base collection')

function parse (response) {
  var schemata = this.model.prototype.schemata
  if (response.results) {
    this.totalItems = response.totalItems
    return response.results.map(function (item) {
      return schemata.cast(item)
    })
  }
  return response.map(function (item) {
    return schemata.cast(item)
  })
}

var sortDirectionTable = { 'asc': 1, 'desc': -1 }

module.exports = Backbone.Collection.extend(
  { parse: parse

  // Pagination
  , pageSize: 50
  , currentPage: 1
  , totalItems: 0

  // Sort properties
  , sortProperty: 'dateCreated'
  , sortDirection: 'desc'
  , currentFilter: {}
  , defaultFilter: {}
  , currentParams: {}

    /*
     * Comparator function used by
     * Backbone.Collection.prototype.sort()
     * Returns:
     *    0 - If a and b are of 'equal' order
     *   -1 - If a should come before b
     *   +1 - If b sould come before a
     */
  , comparator: function (a, b) {
      if (!this.sortProperty || !this.sortDirection) {
        throw new Error('sortDirection and sortProperty must be defined on the collection')
      }
      var aProp = a.get(this.sortProperty)
        , bProp = b.get(this.sortProperty)
        , d = sortDirectionTable[this.sortDirection]
      if (deepEqual(aProp, bProp)) return 0
      return aProp > bProp ? d * 1 : d * -1
    }

    /*
     * Apply a filter in the form
     * { sort: [...], filter: {...} }
     * to the collection.
     */
  , applyFilter: function (params, preserveCurrentPage) {

      /* eslint complexity: [ 2, 7 ] */

      if (!params && preserveCurrentPage) {
        params = _.extend({}, { filter: this.defaultFilter }, this.currentParams)
      } else if (!params) {
        params = { filter: this.defaultFilter }
      }

      // If not keeping the current set, reset pagination & remove models
      if (!preserveCurrentPage) {
        this.currentPage = 1
        this.remove(this.models)
      }

      // Get sort properties from query
      if (params.sort && params.sort.length) {
        this.sortProperty = params.sort[0]
        this.sortDirection = params.sort[1]
      } else {
        params.sort = [ this.sortProperty, this.sortDirection ]
      }

      // If no filters came in, set them to the defaults
      if (!params.filter || Object.keys(params.filter).length < 1) {
        params.filter = this.defaultFilter
      } else {
        this.currentFilter = params.filter
      }

      // Deal with pagination
      params.pagination =
        { pageSize: this.pageSize
        , page: this.currentPage
        }

      this.currentParams = _.clone(params)

      // Write the params to JSON
      Object.keys(params).forEach(function (key) {
        params[key] = JSON.stringify(params[key])
      })

      debug('Sending GET with params', params)

      this.fetch(
        { update: true
        , data: params
        , remove: !preserveCurrentPage
        , success: _.bind(function () {
            this.sort({ silent: true })
            this.trigger('filter')
          }, this)
        })
    }

  , loadMore: function () {
      this.currentPage++
      this.applyFilter(null, true)
    }

    /*
     * Reset the collection and load in the
     * contents, applying the default filter.
     */
  , load: function () {
      this.reset([])
      this.applyFilter({ filter: this.defaultFilter })
    }

    /*
     * Retrieves a model by id, ensuring (if it
     * exists on the backend) that it is held
     * within the collection.
     * `cb` is expected to be: `function (err, model) {...}`
     */
  , retrieve: function (id, cb) {

      var model
      model = this.get(id)
      if (model) return cb(null, model)

      function onSuccess () {
        // TODO: to ensure widget areas get rendered on refresh. Risk of Cyclic pain?
        model.initialize()
        return cb(null, model)
      }

      function onError () {
        this.remove(model)
        return cb(new Error('An item with id "' + id + '" could not be retrieved'))
      }

      this.add({ _id: id })
      model = this.get(id)
      model.fetch(
        { success: onSuccess
        , error: onError.bind(this)
        })

    }
  })

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/base-collection.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkbWluL3NvdXJjZS9qcy9hcHAvbGliL2Jhc2UtY29sbGVjdGlvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJ2YXIgXyA9IHJlcXVpcmUoJ2xvZGFzaCcpXG4gICwgZGVlcEVxdWFsID0gcmVxdWlyZSgnZGVlcC1lcXVhbCcpXG4gICwgZGVidWcgPSByZXF1aXJlKCcuL2RlYnVnJykoJ2Jhc2UgY29sbGVjdGlvbicpXG5cbmZ1bmN0aW9uIHBhcnNlIChyZXNwb25zZSkge1xuICB2YXIgc2NoZW1hdGEgPSB0aGlzLm1vZGVsLnByb3RvdHlwZS5zY2hlbWF0YVxuICBpZiAocmVzcG9uc2UucmVzdWx0cykge1xuICAgIHRoaXMudG90YWxJdGVtcyA9IHJlc3BvbnNlLnRvdGFsSXRlbXNcbiAgICByZXR1cm4gcmVzcG9uc2UucmVzdWx0cy5tYXAoZnVuY3Rpb24gKGl0ZW0pIHtcbiAgICAgIHJldHVybiBzY2hlbWF0YS5jYXN0KGl0ZW0pXG4gICAgfSlcbiAgfVxuICByZXR1cm4gcmVzcG9uc2UubWFwKGZ1bmN0aW9uIChpdGVtKSB7XG4gICAgcmV0dXJuIHNjaGVtYXRhLmNhc3QoaXRlbSlcbiAgfSlcbn1cblxudmFyIHNvcnREaXJlY3Rpb25UYWJsZSA9IHsgJ2FzYyc6IDEsICdkZXNjJzogLTEgfVxuXG5tb2R1bGUuZXhwb3J0cyA9IEJhY2tib25lLkNvbGxlY3Rpb24uZXh0ZW5kKFxuICB7IHBhcnNlOiBwYXJzZVxuXG4gIC8vIFBhZ2luYXRpb25cbiAgLCBwYWdlU2l6ZTogNTBcbiAgLCBjdXJyZW50UGFnZTogMVxuICAsIHRvdGFsSXRlbXM6IDBcblxuICAvLyBTb3J0IHByb3BlcnRpZXNcbiAgLCBzb3J0UHJvcGVydHk6ICdkYXRlQ3JlYXRlZCdcbiAgLCBzb3J0RGlyZWN0aW9uOiAnZGVzYydcbiAgLCBjdXJyZW50RmlsdGVyOiB7fVxuICAsIGRlZmF1bHRGaWx0ZXI6IHt9XG4gICwgY3VycmVudFBhcmFtczoge31cblxuICAgIC8qXG4gICAgICogQ29tcGFyYXRvciBmdW5jdGlvbiB1c2VkIGJ5XG4gICAgICogQmFja2JvbmUuQ29sbGVjdGlvbi5wcm90b3R5cGUuc29ydCgpXG4gICAgICogUmV0dXJuczpcbiAgICAgKiAgICAwIC0gSWYgYSBhbmQgYiBhcmUgb2YgJ2VxdWFsJyBvcmRlclxuICAgICAqICAgLTEgLSBJZiBhIHNob3VsZCBjb21lIGJlZm9yZSBiXG4gICAgICogICArMSAtIElmIGIgc291bGQgY29tZSBiZWZvcmUgYVxuICAgICAqL1xuICAsIGNvbXBhcmF0b3I6IGZ1bmN0aW9uIChhLCBiKSB7XG4gICAgICBpZiAoIXRoaXMuc29ydFByb3BlcnR5IHx8ICF0aGlzLnNvcnREaXJlY3Rpb24pIHtcbiAgICAgICAgdGhyb3cgbmV3IEVycm9yKCdzb3J0RGlyZWN0aW9uIGFuZCBzb3J0UHJvcGVydHkgbXVzdCBiZSBkZWZpbmVkIG9uIHRoZSBjb2xsZWN0aW9uJylcbiAgICAgIH1cbiAgICAgIHZhciBhUHJvcCA9IGEuZ2V0KHRoaXMuc29ydFByb3BlcnR5KVxuICAgICAgICAsIGJQcm9wID0gYi5nZXQodGhpcy5zb3J0UHJvcGVydHkpXG4gICAgICAgICwgZCA9IHNvcnREaXJlY3Rpb25UYWJsZVt0aGlzLnNvcnREaXJlY3Rpb25dXG4gICAgICBpZiAoZGVlcEVxdWFsKGFQcm9wLCBiUHJvcCkpIHJldHVybiAwXG4gICAgICByZXR1cm4gYVByb3AgPiBiUHJvcCA/IGQgKiAxIDogZCAqIC0xXG4gICAgfVxuXG4gICAgLypcbiAgICAgKiBBcHBseSBhIGZpbHRlciBpbiB0aGUgZm9ybVxuICAgICAqIHsgc29ydDogWy4uLl0sIGZpbHRlcjogey4uLn0gfVxuICAgICAqIHRvIHRoZSBjb2xsZWN0aW9uLlxuICAgICAqL1xuICAsIGFwcGx5RmlsdGVyOiBmdW5jdGlvbiAocGFyYW1zLCBwcmVzZXJ2ZUN1cnJlbnRQYWdlKSB7XG5cbiAgICAgIC8qIGVzbGludCBjb21wbGV4aXR5OiBbIDIsIDcgXSAqL1xuXG4gICAgICBpZiAoIXBhcmFtcyAmJiBwcmVzZXJ2ZUN1cnJlbnRQYWdlKSB7XG4gICAgICAgIHBhcmFtcyA9IF8uZXh0ZW5kKHt9LCB7IGZpbHRlcjogdGhpcy5kZWZhdWx0RmlsdGVyIH0sIHRoaXMuY3VycmVudFBhcmFtcylcbiAgICAgIH0gZWxzZSBpZiAoIXBhcmFtcykge1xuICAgICAgICBwYXJhbXMgPSB7IGZpbHRlcjogdGhpcy5kZWZhdWx0RmlsdGVyIH1cbiAgICAgIH1cblxuICAgICAgLy8gSWYgbm90IGtlZXBpbmcgdGhlIGN1cnJlbnQgc2V0LCByZXNldCBwYWdpbmF0aW9uICYgcmVtb3ZlIG1vZGVsc1xuICAgICAgaWYgKCFwcmVzZXJ2ZUN1cnJlbnRQYWdlKSB7XG4gICAgICAgIHRoaXMuY3VycmVudFBhZ2UgPSAxXG4gICAgICAgIHRoaXMucmVtb3ZlKHRoaXMubW9kZWxzKVxuICAgICAgfVxuXG4gICAgICAvLyBHZXQgc29ydCBwcm9wZXJ0aWVzIGZyb20gcXVlcnlcbiAgICAgIGlmIChwYXJhbXMuc29ydCAmJiBwYXJhbXMuc29ydC5sZW5ndGgpIHtcbiAgICAgICAgdGhpcy5zb3J0UHJvcGVydHkgPSBwYXJhbXMuc29ydFswXVxuICAgICAgICB0aGlzLnNvcnREaXJlY3Rpb24gPSBwYXJhbXMuc29ydFsxXVxuICAgICAgfSBlbHNlIHtcbiAgICAgICAgcGFyYW1zLnNvcnQgPSBbIHRoaXMuc29ydFByb3BlcnR5LCB0aGlzLnNvcnREaXJlY3Rpb24gXVxuICAgICAgfVxuXG4gICAgICAvLyBJZiBubyBmaWx0ZXJzIGNhbWUgaW4sIHNldCB0aGVtIHRvIHRoZSBkZWZhdWx0c1xuICAgICAgaWYgKCFwYXJhbXMuZmlsdGVyIHx8IE9iamVjdC5rZXlzKHBhcmFtcy5maWx0ZXIpLmxlbmd0aCA8IDEpIHtcbiAgICAgICAgcGFyYW1zLmZpbHRlciA9IHRoaXMuZGVmYXVsdEZpbHRlclxuICAgICAgfSBlbHNlIHtcbiAgICAgICAgdGhpcy5jdXJyZW50RmlsdGVyID0gcGFyYW1zLmZpbHRlclxuICAgICAgfVxuXG4gICAgICAvLyBEZWFsIHdpdGggcGFnaW5hdGlvblxuICAgICAgcGFyYW1zLnBhZ2luYXRpb24gPVxuICAgICAgICB7IHBhZ2VTaXplOiB0aGlzLnBhZ2VTaXplXG4gICAgICAgICwgcGFnZTogdGhpcy5jdXJyZW50UGFnZVxuICAgICAgICB9XG5cbiAgICAgIHRoaXMuY3VycmVudFBhcmFtcyA9IF8uY2xvbmUocGFyYW1zKVxuXG4gICAgICAvLyBXcml0ZSB0aGUgcGFyYW1zIHRvIEpTT05cbiAgICAgIE9iamVjdC5rZXlzKHBhcmFtcykuZm9yRWFjaChmdW5jdGlvbiAoa2V5KSB7XG4gICAgICAgIHBhcmFtc1trZXldID0gSlNPTi5zdHJpbmdpZnkocGFyYW1zW2tleV0pXG4gICAgICB9KVxuXG4gICAgICBkZWJ1ZygnU2VuZGluZyBHRVQgd2l0aCBwYXJhbXMnLCBwYXJhbXMpXG5cbiAgICAgIHRoaXMuZmV0Y2goXG4gICAgICAgIHsgdXBkYXRlOiB0cnVlXG4gICAgICAgICwgZGF0YTogcGFyYW1zXG4gICAgICAgICwgcmVtb3ZlOiAhcHJlc2VydmVDdXJyZW50UGFnZVxuICAgICAgICAsIHN1Y2Nlc3M6IF8uYmluZChmdW5jdGlvbiAoKSB7XG4gICAgICAgICAgICB0aGlzLnNvcnQoeyBzaWxlbnQ6IHRydWUgfSlcbiAgICAgICAgICAgIHRoaXMudHJpZ2dlcignZmlsdGVyJylcbiAgICAgICAgICB9LCB0aGlzKVxuICAgICAgICB9KVxuICAgIH1cblxuICAsIGxvYWRNb3JlOiBmdW5jdGlvbiAoKSB7XG4gICAgICB0aGlzLmN1cnJlbnRQYWdlKytcbiAgICAgIHRoaXMuYXBwbHlGaWx0ZXIobnVsbCwgdHJ1ZSlcbiAgICB9XG5cbiAgICAvKlxuICAgICAqIFJlc2V0IHRoZSBjb2xsZWN0aW9uIGFuZCBsb2FkIGluIHRoZVxuICAgICAqIGNvbnRlbnRzLCBhcHBseWluZyB0aGUgZGVmYXVsdCBmaWx0ZXIuXG4gICAgICovXG4gICwgbG9hZDogZnVuY3Rpb24gKCkge1xuICAgICAgdGhpcy5yZXNldChbXSlcbiAgICAgIHRoaXMuYXBwbHlGaWx0ZXIoeyBmaWx0ZXI6IHRoaXMuZGVmYXVsdEZpbHRlciB9KVxuICAgIH1cblxuICAgIC8qXG4gICAgICogUmV0cmlldmVzIGEgbW9kZWwgYnkgaWQsIGVuc3VyaW5nIChpZiBpdFxuICAgICAqIGV4aXN0cyBvbiB0aGUgYmFja2VuZCkgdGhhdCBpdCBpcyBoZWxkXG4gICAgICogd2l0aGluIHRoZSBjb2xsZWN0aW9uLlxuICAgICAqIGBjYmAgaXMgZXhwZWN0ZWQgdG8gYmU6IGBmdW5jdGlvbiAoZXJyLCBtb2RlbCkgey4uLn1gXG4gICAgICovXG4gICwgcmV0cmlldmU6IGZ1bmN0aW9uIChpZCwgY2IpIHtcblxuICAgICAgdmFyIG1vZGVsXG4gICAgICBtb2RlbCA9IHRoaXMuZ2V0KGlkKVxuICAgICAgaWYgKG1vZGVsKSByZXR1cm4gY2IobnVsbCwgbW9kZWwpXG5cbiAgICAgIGZ1bmN0aW9uIG9uU3VjY2VzcyAoKSB7XG4gICAgICAgIC8vIFRPRE86IHRvIGVuc3VyZSB3aWRnZXQgYXJlYXMgZ2V0IHJlbmRlcmVkIG9uIHJlZnJlc2guIFJpc2sgb2YgQ3ljbGljIHBhaW4/XG4gICAgICAgIG1vZGVsLmluaXRpYWxpemUoKVxuICAgICAgICByZXR1cm4gY2IobnVsbCwgbW9kZWwpXG4gICAgICB9XG5cbiAgICAgIGZ1bmN0aW9uIG9uRXJyb3IgKCkge1xuICAgICAgICB0aGlzLnJlbW92ZShtb2RlbClcbiAgICAgICAgcmV0dXJuIGNiKG5ldyBFcnJvcignQW4gaXRlbSB3aXRoIGlkIFwiJyArIGlkICsgJ1wiIGNvdWxkIG5vdCBiZSByZXRyaWV2ZWQnKSlcbiAgICAgIH1cblxuICAgICAgdGhpcy5hZGQoeyBfaWQ6IGlkIH0pXG4gICAgICBtb2RlbCA9IHRoaXMuZ2V0KGlkKVxuICAgICAgbW9kZWwuZmV0Y2goXG4gICAgICAgIHsgc3VjY2Vzczogb25TdWNjZXNzXG4gICAgICAgICwgZXJyb3I6IG9uRXJyb3IuYmluZCh0aGlzKVxuICAgICAgICB9KVxuXG4gICAgfVxuICB9KVxuIl19